import { render } from "./BlockCard.vue?vue&type=template&id=4b5f4c4f&scoped=true"
import script from "./BlockCard.vue?vue&type=script&lang=js"
export * from "./BlockCard.vue?vue&type=script&lang=js"

import "./BlockCard.vue?vue&type=style&index=0&id=4b5f4c4f&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5f4c4f"]])

export default __exports__